const ChatType = {
  FRIEND: "0",
  GROUP: "1",
};
export default ChatType;
